export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-reddit-b36806d52240c158b957c1b4af0524f5.svg";